import { ILineItemSubtype } from 'common/src/types/interfaces';

import { textInputType } from 'portal/src/components/common/forms/FormFieldTypes';

export const defaultValues = (entity: Partial<ILineItemSubtype> = {}) => {
  return {
    name: entity.name ?? '',
    description: entity.description ?? '',
  };
};

export const getLineItemSubTypeFields = () => {
  const formFieldsConfiguration: Array<textInputType> = [
    {
      placeholder: 'Name',
      label: 'Name',
      name: 'name',
      type: 'textInput',
      required: true,
    },
    {
      placeholder: 'Description',
      label: 'Description',
      name: 'description',
      type: 'textInput',
      required: false,
    },
  ];

  return formFieldsConfiguration;
};
